import { useQuery } from '@tanstack/react-query';
import { Permission } from '@klaro7/shared-types';

import { usePermissions } from '@/features/rbac/usePermissions';
import { getAdminSessions } from '../services/questionnaire-admin.service';

/**
 * Numero di questionari completati in attesa di revisione, per il badge in
 * sidebar. Riusa la list admin (limit=1, serve solo pagination.total) e vive
 * sotto il prefix ['questionnaire-admin'], così approve/reject la invalidano
 * e il conteggio scende subito.
 */
export function useQuestionnairesPendingBadge(): number {
  const { can } = usePermissions();
  const enabled = can(Permission.ADMIN_ACCESS);

  const { data } = useQuery({
    queryKey: ['questionnaire-admin', 'pending-badge'],
    queryFn: () => getAdminSessions({ status: 'completed', limit: 1 }),
    enabled,
    staleTime: 1000 * 30,
    refetchInterval: 1000 * 60,
  });

  return enabled ? (data?.pagination?.total ?? 0) : 0;
}
